import { ButtonHTMLAttributes } from "react";
import { twMerge } from 'tailwind-merge'

interface TextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    text?: string,
    variant?: "primary" | "secondary" | "none",
}

export function Text({ text, variant = "primary", ...rest }: TextProps) {
    return (
        <span
            {...rest}
            className={twMerge(
                "tw-font-medium tw-text-base ",
                variant == "primary" && "tw-text-white",
                variant == "secondary" && "tw-text-red-500",
                variant == "none" && "",
                rest.className
            )}
        >
            {text}
        </span>
    )
}